import partial from "lodash/partial";
import React, { useEffect, useState } from "react";
import { ControlLabel, FormGroup, Popover } from "react-bootstrap";
import NumberFormat from "react-number-format";
import Moment from "moment";
import CalendarInput, { DateDisplay } from "../calendar-input";

export const useNumberOverlay = (...args) => partial(useNumberOverlayWithClose, ...args);
const useNumberOverlayWithClose = ({ label, confirmText, onChange, startValue, prefix }, close) => {
  const [value, updateValue] = useState(startValue ?? 0);
  useEffect(() => updateValue(startValue), [startValue]);
  return (
    <Popover id="calendar-input" className={"height-auto width-max-content black-text"}>
      <FormGroup controlId={"total-budget-picker"}>
        <ControlLabel>{label}</ControlLabel>
        <NumberFormat
          prefix={prefix}
          className={"width-100 form-control"}
          thousandSeparator={true}
          value={value}
          decimalScale={0}
          autoFocus
          onValueChange={value => updateValue(value.floatValue)}
        />
      </FormGroup>
      <div
        className="fake-link margin-top--small text-right"
        onClick={() => {
          onChange(value);
          close();
        }}>
        {confirmText}
      </div>
    </Popover>
  );
};
export const CalendarOverlay = (...args) => partial(useCalendarOverlayWithClose, ...args);
const useCalendarOverlayWithClose = (editableDate, onChange, dummyDate, close, minDate) => {
  const [targetDate, updateTargetDate] = useState(Moment(editableDate));
  /* eslint-disable */
  useEffect(() => updateTargetDate(Moment(editableDate)), [Moment(editableDate).format("LL")]);
  return (
    <Popover id="calendar-input" className={"height-auto width-max-content"}>
      <div onClick={e => e.stopPropagation()}>
        <DateDisplay value={dummyDate} noRange className={"margin-bottom--small"} />
        <CalendarInput
          minDate={minDate || dummyDate?.toDate()}
          input={{ value: targetDate }}
          onChange={date => updateTargetDate(date)}
          noRange
        />
        <div
          className="fake-link margin-top--small text-right"
          onClick={() => {
            // need to set it to one second otherwise there's a rounding error and the duration will round down
            updateTargetDate(targetDate);
            onChange(targetDate);
            close();
          }}>
          Set Downloads
        </div>
      </div>
    </Popover>
  );
};
